import styled from 'styled-components';
import { Checkbox, FormControlLabel, Pagination, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { LocalTabContent } from '@styles/CommonStyles';
import { Select } from '@shared/inputs/Select';
import { Row } from '@styles/StyledDiv';
import { colorTheme, extraColor } from '@styles/muiTheme';

export const WorkflowDetailsContent = styled.div<{ isDeal: boolean }>(
  ({ isDeal, theme: { palette } }) => `
  flex: 1;
  font-size: 14px;
  background: transparent linear-gradient(93deg, ${isDeal ? palette.success.main : palette.info.dark}  0%, ${isDeal ? '#104812' : '#BA4F2C'}  100%) 0% 0% no-repeat padding-box;
  min-width: 38rem;
  
  ${Row} {
    margin-bottom: 5px;
  }
  div.reasons-card::-webkit-scrollbar-track {
	  box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	  background-color: ${colorTheme.palette.common.white};
  }

  div.reasons-card::-webkit-scrollbar {
    width: 10px;
    background-color: #f9f9f9;
  }

  div.reasons-card::-webkit-scrollbar-thumb {
    background-color: ${colorTheme.palette.common.white};
    width: 10px;
  }
  div.next-steps div div:first-child {
    color: ${colorTheme.palette.common.white};
  }
  div.next-steps .MuiOutlinedInput-root svg.MuiSelect-icon.MuiSelect-iconOutlined {
    fill: ${colorTheme.palette.common.white};
  }
`
);

export const StyledPagination = styled(Pagination)`
  position: absolute;
  bottom: 20px;
  right: 20px;

  .MuiPaginationItem-text {
    color: ${colorTheme.palette.common.white};
    font-weight: 600;
  }

  .MuiPaginationItem-text:hover {
    background-color: rgba(0, 0, 0, 0.4);
  }

  .Mui-selected,
  .Mui-selected:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }
`;

export const RowName = styled.p`
  color: ${colorTheme.palette.common.white};
  letter-spacing: 0;
  min-width: 50px;
`;

export const RowInfo = styled.p`
  color: ${colorTheme.palette.common.white};
  letter-spacing: 0;
  font-weight: 700;
  width: 150px;
`;

export const StyledFormControlLabel = styled(FormControlLabel)`
  height: auto;
  padding-left: 9px;
  span,
  p {
    display: inline-block;
    padding: 0;
    border-radius: 0;
    align-items: start;
  }
  p {
    min-width: 108px;
    margin-left: 4px;
    margin-bottom: 10px;
  }
`;

export const StyledSelect = styled(Select)`
  background: transparent;
  border: none;
  max-width: 185px;
  
  & .MuiSelect-select {
    background: ${extraColor.palette.grey[400]};
    border-radius: 6px;
    min-height: 30px;
    svg {
      fill: ${colorTheme.palette.common.white};
    }
  }
`;

export const PageContent = styled(LocalTabContent)`
  height: auto;
  .show-desc-text {
    display: block;
  }
  .hide-desc-text {
    display: none;
  }
  div.MuiGrid-container {
    display: block;
  }
  div.MuiGrid-item input[type='checkbox'] {
    width: 20px;
    height: 18px;
  }
  div.MuiGrid-item input[type='checkbox']:checked {
    background-color: ${colorTheme.palette.primary.light} !important;
  }
  div.MuiGrid-item div.MuiBox-root {
    margin-bottom: 10px;
    span {
      vertical-align: top;
      margin-left: 10px;
    }
  }
  div.MuiGrid-item:not(:first-child) {
    padding-top: 0px;
    display: block;
  }
  div.MuiGrid-item::first-child {
    padding-top: 15px;
    display: block;
  }
`;

export const WorkflowNextSteps = styled.div`
  div div:first-child {
    color: ${colorTheme.palette.common.white};
  }
  .MuiOutlinedInput-root svg.MuiSelect-icon.MuiSelect-iconOutlined {
    fill: ${colorTheme.palette.common.white};
  }
`;

export const WorkflowReasonCard = styled(Box)`
  padding: 0 0 0 5px;
`;

export const StyledReasonCheckbox = styled(Checkbox)`
  padding: 2px 9px 2px 9px;
  color: ${colorTheme.palette.secondary.dark};
  align-items: start;
`;

export const StyledSelectLabel = styled(Typography)`
  font-size: 11px;
  font-weight: 700;
  position: absolute;
  top: 10;
`;

export const WorkflowContainer = styled(Stack)<{ length: number, index: number }>(
  ({ length, index }) => `
  flex: 1 1 180px;
  padding-right: 20px;
  border-right: ${ length - 1 !== index ? `0.1px solid ${colorTheme.palette.common.white}` : '' };
`);

export const EmptyWorkflowContainer = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
